<template>
  <div class="zuimintj">
    <sub-title :text="tjtitle" />
    <div class="tjlist">
      <div class="tjitem ellipsis" v-for="item in xhnum" :key="item">
        {{moniwx}}
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props:{
    tjtitle:{
      type:String,
      default:"刑法罪名库"
    },
    xhnum:{
      type:Number,
      default:6
    },
    moniwx:{//模拟文字，后期删除
      type:String,
      default:" 生产、销售伪劣商品罪(9个)"
    },
  },
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.zuimintj {
  padding: 24px 12px;
  .tjlist {
    padding: 0 10px 0 16px;
    .tjitem {
      cursor: pointer;
      margin-top: 24px;
      font-size: 16px;
      color: #333333;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>